const theme = {
  colors: {
    primary: '#2d7a3a',
    primaryLight: '#e8f5e9',
    accent: '#e67e22',

    white: '#ffffff',
    background: '#f9f9f9',
    backgroundAlt: '#f0f0f0',

    textPrimary: '#333333',
    textSecondary: '#666666',
    textMuted: '#999999',

    border: '#e0e0e0',
    borderInput: '#dddddd',

    success: '#2d7a3a',
    successBg: '#e8f5e9',
    warning: '#e65100',
    warningBg: '#fff3e0',
    warningBorder: '#ffe082',
    warningBgSoft: '#fff8e1',
    warningText: '#f57f17',
    error: '#e74c3c',
    errorDark: '#c0392b',
    errorBg: '#fce4e4',
    errorBorder: '#ef9a9a',
    info: '#1565c0',
    infoBg: '#e3f2fd',
    starGold: '#f4c430',
  },

  layout: {
    maxWidth: 480,
  },

  radius: {
    sm: 8,
    md: 10,
    lg: 12,
    pill: 20,
    circle: '50%',
  },

  spacing: {
    xs: 4,
    sm: 8,
    md: 12,
    lg: 16,
    xl: 20,
    xxl: 24,
  },

  font: {
    family: 'sans-serif',
    size: {
      xs: 11,
      sm: 12,
      base: 13,
      md: 14,
      lg: 15,
      xl: 16,
      xxl: 18,
      heading: 22,
      hero: 26,
    },
  },

  shadow: {
    card: '0 1px 4px rgba(0,0,0,0.08)',
    popup: '0 2px 8px rgba(0,0,0,0.1)',
    floating: '0 4px 20px rgba(0,0,0,0.15)',
  },

  bubble: {
    mine: '16px 16px 4px 16px',
    theirs: '16px 16px 16px 4px',
  },
};

export default theme;